const PREP_INK = "#557c2e";
const PREP_BG = "#f2f7ec";
const PREP_LINE = "#dfeacf";

// The API sends placeholder entries — a product with no prep options comes
// back as shoppingInstructions: [""], so a length check alone is not enough.
const isRealInstruction = (instruction) => {
  if (!instruction) return false;
  if (typeof instruction === "string") return instruction.trim() !== "";
  if (typeof instruction === "object")
    return Object.keys(instruction).length > 0;
  return true;
};

export const hasPrepService = (product) =>
  Array.isArray(product?.shoppingInstructions) &&
  product.shoppingInstructions.some(isRealInstruction);

// Knife + board mark — signals "we can wash / blend / cut this for you".
export const KnifeIcon = ({ size = 12, color = PREP_INK }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M4 14L14 4c2.6 1.4 4.2 4 4 7l-6 6z" />
    <path d="M12 17l-4 4-3-3" />
  </svg>
);

const PrepBadge = ({ isMobile = false, style = {} }) => (
  <div
    className="d-inline-flex align-items-center"
    style={{
      gap: "5px",
      background: PREP_BG,
      border: `1px solid ${PREP_LINE}`,
      borderRadius: "7px",
      padding: isMobile ? "3px 6px" : "4px 8px",
      // Hug the label rather than stretching to the card width.
      width: "fit-content",
      maxWidth: "100%",
      ...style,
    }}
  >
    <KnifeIcon size={isMobile ? 11 : 12} />
    <span
      style={{
        fontSize: isMobile ? "10px" : "11px",
        fontWeight: 700,
        color: PREP_INK,
        lineHeight: 1.1,
        whiteSpace: "nowrap",
      }}
    >
      Prep available
    </span>
  </div>
);

export default PrepBadge;
